<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="B2338、B2442、M1242、MS321、MS421 プリンタ">
     B2338、B2442、M1242、MS321、MS421 プリンタ
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_ja" title="安全情報">
     安全情報
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="表記規則">
      表記規則
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-power-cord-topic.html#d0e42" title="製品ステートメント">
      製品ステートメント
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter_ja" title="プリンタの詳細">
     プリンタの詳細
    </a>
   </p>
   <div id="divd0e179">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_ja" title="プリンタに関する情報を見つける">
      プリンタに関する情報を見つける
     </a>
    </p>
    <p class="toc-2-style">
     <a href="selecting-location-printer-m-topic.html#selecting-location-printer-m_ja" title="プリンタの設置場所を選択する">
      プリンタの設置場所を選択する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations_ja" title="プリンタ構成">
      プリンタ構成
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables_ja" title="ケーブルを接続する">
      ケーブルを接続する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_ja" title="操作パネルを使用する">
      操作パネルを使用する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light_ja" title="電源ボタンとインジケータランプの状態について理解する">
      電源ボタンとインジケータランプの状態について理解する
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="loading-paper-and-specialty-media-chapter.html#loading-paper-and-specialty-media-chapter_ja" title="用紙と特殊紙をセットする">
     用紙と特殊紙をセットする
    </a>
   </p>
   <div id="divd0e736">
    <p class="toc-2-style">
     <a href="setting-size-and-type-of-specialty-media-topic.html#setting-size-and-type-of-specialty-media_ja" title="特殊紙のサイズとタイプを設定する">
      特殊紙のサイズとタイプを設定する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-universal-paper-settings-h1-topic.html#configuring-universal-paper-settings-h1_ja" title="ユニバーサル用紙設定を設定する">
      ユニバーサル用紙設定を設定する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-trays-topic.html#loading-trays_ja" title="用紙をトレイにセットする">
      用紙をトレイにセットする
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-multipurpose-feeder-topic.html#loading-multipurpose-feeder_ja" title="手差しトレイに用紙をセットする">
      手差しトレイに用紙をセットする
     </a>
    </p>
    <p class="toc-2-style">
     <a href="linking-and-unlinking-trays-topic.html#linking-and-unlinking-trays_ja" title="トレイのリンク">
      トレイのリンク
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="supported-paper-sizes-types-and-weights-chapter.html#supported-paper-sizes-types-and-weights-chapter_ja" title="用紙サポート">
     用紙サポート
    </a>
   </p>
   <div id="divd0e929">
    <p class="toc-2-style">
     <a href="supported-paper-sizes-gsm-topic.html#supported-paper-sizes-gsm_ja" title="サポートされている用紙サイズ">
      サポートされている用紙サイズ
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-types-gold-topic.html#supported-paper-types-gold_ja" title="サポートされている用紙タイプ">
      サポートされている用紙タイプ
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-paper-weights-gsm-topic.html#supported-paper-weights-gsm_ja" title="サポートされている用紙重量">
      サポートされている用紙重量
     </a>
    </p>
    <p class="toc-2-style">
     <a href="unacceptable-paper-topic.html#unacceptable-paper_ja" title="使用できない用紙">
      使用できない用紙
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-recycled-paper-topic.html#using-recycled-paper_ja" title="再生紙を使用する">
      再生紙を使用する
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter_ja" title="印刷">
     印刷
    </a>
   </p>
   <div id="divd0e1536">
    <p class="toc-2-style">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2_ja" title="コンピュータから印刷する">
      コンピュータから印刷する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e1562" title="モバイルデバイスから印刷する">
      モバイルデバイスから印刷する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-h2-topic.html#printing-font-sample-list-h2_ja" title="フォントサンプルリストを印刷する">
      フォントサンプルリストを印刷する
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="understanding-printer-menus-chapter.html#understanding-printer-menus-chapter_ja" title="プリンタメニューを理解する">
     プリンタメニューを理解する
    </a>
   </p>
   <div id="divd0e1706">
    <p class="toc-2-style">
     <a href="menus-map-topic.html#menus-map_ja" title="メニューマップ">
      メニューマップ
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e1885" title="デバイス">
      デバイス
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e2851" title="印刷">
      印刷
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e3828" title="用紙">
      用紙
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e4065" title="ネットワーク/ポート">
      ネットワーク/ポート
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e5545" title="レポート">
      レポート
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-group.html#d0e5674" title="トラブルシューティング">
      トラブルシューティング
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-h1-topic.html#printing-menu-settings-page-h1_ja" title="メニュー設定ページを印刷する">
      メニュー設定ページを印刷する
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_ja" title="プリンタを保護する">
     プリンタを保護する
    </a>
   </p>
   <div id="divd0e5728">
    <p class="toc-2-style">
     <a href="locating-security-slot-topic.html#locating-security-slot_ja" title="セキュリティスロットの場所">
      セキュリティスロットの場所
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_ja" title="プリンタメモリを消去する">
      プリンタメモリを消去する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_ja" title="工場出荷時設定に復元する">
      工場出荷時設定に復元する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-h2-topic.html#statement-of-volatility-h2_ja" title="揮発性に関する記述">
      揮発性に関する記述
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_ja" title="プリンタのメンテナンス">
     プリンタのメンテナンス
    </a>
   </p>
   <div id="divd0e5900">
    <p class="toc-2-style">
     <a href="connecting-printer-to-wireless-network-topic.html#d0e5905" title="ネットワーク">
      ネットワーク
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#cleaning-printer_ja" title="プリンタを清掃する">
      プリンタを清掃する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-supplies.html#ordering-supplies_ja" title="部品と消耗品を注文する">
      部品と消耗品を注文する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-toner-cartridge-topic.html#d0e6526" title="消耗品を交換する">
      消耗品を交換する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-the-printer.html#moving-the-printer_ja" title="プリンタを移動する">
      プリンタを移動する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-power-save-mode-settings-topic.html#d0e6725" title="電力と用紙を節約する">
      電力と用紙を節約する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling-lexmark-products-topic.html#d0e6873" title="リサイクル">
      リサイクル
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="clearing-jams-chapter.html#clearing-jams-chapter_ja" title="紙詰まりを取り除く">
     紙詰まりを取り除く
    </a>
   </p>
   <div id="divd0e6927">
    <p class="toc-2-style">
     <a href="avoiding-jams-topic.html#avoiding-jams_ja" title="紙詰まりを防止する">
      紙詰まりを防止する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="identifying-jam-locations-topic.html#identifying-jam-locations_ja" title="紙詰まりの場所を確認する">
      紙詰まりの場所を確認する
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-door-a-topic.html#paper-jam-in-front-door_ja" title="ドア A の紙詰まり">
      ドア A の紙詰まり
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-rear-door-topic.html#paper-jam-in-rear-door_ja" title="背面ドアの紙詰まり">
      背面ドアの紙詰まり
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-standard-bin-topic.html#paper-jam-in-standard-bin_ja" title="標準排紙トレイの紙詰まり">
      標準排紙トレイの紙詰まり
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-jam-in-duplex-unit-topic.html#paper-jam-in-duplex-unit_ja" title="両面印刷ユニット内の紙詰まり">
      両面印刷ユニット内の紙詰まり
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-paper-jam-trays-topic.html#message-paper-jam-trays_ja" title="トレイの紙詰まり">
      トレイの紙詰まり
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-paper-jam-mpf-topic.html#message-paper-jam-mpf_ja" title="多目的フィーダの紙詰まり">
      多目的フィーダの紙詰まり
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_ja" title="トラブルシューティング">
     トラブルシューティング
    </a>
   </p>
   <div id="divd0e7203">
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e7206" title="ネットワーク接続の問題">
      ネットワーク接続の問題
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e7353" title="消耗品の問題">
      消耗品の問題
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-envelope-seals-when-printing-topic.html#d0e7499" title="給紙の問題">
      給紙の問題
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-blank-or-white-pages-topic.html#d0e7885" title="印刷の問題">
      印刷の問題
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_ja" title="カスタマサポートに問い合わせる">
      カスタマサポートに問い合わせる
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="upgrading-and-migrating-chapter.html#upgrading-and-migrating-chapter_ja" title="アップグレードと移行">
     アップグレードと移行
    </a>
   </p>
   <div id="divd0e10240">
    <p class="toc-2-style">
     <a href="available-internal-options-topic.html#d0e10243" title="ハードウェア">
      ハードウェア
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e10403" title="ソフトウェア">
      ソフトウェア
     </a>
    </p>
    <p class="toc-2-style">
     <a href="exporting-importing-configuration-using-ews-winners-circle-topic.html#d0e10480" title="ファームウェア">
      ファームウェア
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_ja" title="付録">
     付録
    </a>
   </p>
   <div id="divd0e10549">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e10552" title="製品情報">
      製品情報
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e10569" title="免責">
      免責
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_ja" title="商標">
      商標
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_ja" title="ライセンスに関する通知">
      ライセンスに関する通知
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_ja" title="騒音レベル">
      騒音レベル
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e10663" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_ja" title="製品の廃棄">
      製品の廃棄
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_ja" title="静電気感知に関する通知">
      静電気感知に関する通知
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_ja" title="Energy Star（国際エネルギースター）プログラム">
      Energy Star（国際エネルギースター）プログラム
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_ja" title="温度に関する情報">
      温度に関する情報
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_ja" title="レーザーについて">
      レーザーについて
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_ja" title="電力消費量">
      電力消費量
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e10881" title="ワイヤレス製品に関する規制通知">
      ワイヤレス製品に関する規制通知
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#modular-component-notice_ja" title="モジュールコンポーネントに関する通知事項">
      モジュールコンポーネントに関する通知事項
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#exposure-to-radio-frequency-radiation_ja" title="高周波エネルギーの放射に対する被爆">
      高周波エネルギーの放射に対する被爆
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#japanese-vcci-notice-classb_ja" title="日本の VCCI 規定">
      日本の VCCI 規定
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue